/** Контейнер текста главы (BF-читалка). */
export const BF_READER_CONTAINER_SELECTOR = '.reading-container-books';

/** Временно выкл. выделение текста в читалке (смарт-хайлайт, long-press selection). */
export const READER_TEXT_SELECTION_ENABLED = false;

const VERSE_TEXT_SELECTORS = '.bf-verse__text, .verse-text';

export function isReaderTextSelectionEnabled() {
  return READER_TEXT_SELECTION_ENABLED;
}

/**
 * Непустое выделение внутри колонки чтения (для отличия от тапа по стиху).
 * @returns {string | null} выделенный текст или null
 */
export function getReaderTextSelection(containerSelector = BF_READER_CONTAINER_SELECTOR) {
  if (!READER_TEXT_SELECTION_ENABLED) return null;
  if (typeof window === 'undefined') return null;
  const sel = window.getSelection?.();
  if (!sel || sel.isCollapsed || sel.rangeCount === 0) return null;
  const text = sel.toString().trim();
  if (!text || text.length < 2) return null;
  const container = document.querySelector(containerSelector);
  if (!container) return null;
  const anchorNode = sel.anchorNode;
  if (!anchorNode || !container.contains(anchorNode)) return null;
  return text;
}

export function hasReaderTextSelection(containerSelector = BF_READER_CONTAINER_SELECTOR) {
  return getReaderTextSelection(containerSelector) != null;
}

/** Снять выделение внутри колонки чтения (перед свайпом главы). */
export function clearReaderTextSelection(containerSelector = BF_READER_CONTAINER_SELECTOR) {
  if (typeof window === 'undefined') return;
  const sel = window.getSelection?.();
  if (!sel || sel.isCollapsed) return;
  const container = document.querySelector(containerSelector);
  if (!container) return;
  const anchorNode = sel.anchorNode;
  if (!anchorNode || !container.contains(anchorNode)) return;
  try {
    sel.removeAllRanges();
  } catch {
    /* no-op */
  }
}

/** Горизонтальный жест «свайп главы», не вертикальный скролл / выделение. */
export function isHorizontalSwipeIntent(dx, dy, minDx = 12) {
  const adx = Math.abs(dx);
  const ady = Math.abs(dy);
  return adx >= minDx && adx > ady * 0.85;
}

/** Не начинать свайп главы с блока стиха — только с полей между стихами / отступов. */
export function isChapterSwipeBlockedTarget(target) {
  if (!target?.closest) return false;
  return Boolean(
    target.closest(
      '.bf-verse, .bible-verse, .verse-inline-actions, button, a, input, textarea, select, label, [contenteditable="true"], .bf-verse-toolbar, .bf-popover, .bf-sheet, .chat-page-root'
    )
  );
}

/** Касание по тексту стиха (для свайпа глав — не перехватывать). */
export function isVerseTextPointerTarget(target) {
  if (!target || typeof target.closest !== 'function') return false;
  return Boolean(target.closest(VERSE_TEXT_SELECTORS));
}

/**
 * Жест похож на выделение (вертикальный драг), не короткий тап по стиху.
 * Пороги завышены — на мобиле обычный тап часто 300–450 ms и ± несколько px.
 */
export function looksLikeTextSelectionGesture(startX, startY, endX, endY, durationMs) {
  const dx = Math.abs(endX - startX);
  const dy = Math.abs(endY - startY);
  if (dy >= 20 && dy > dx * 1.2) return true;
  if (durationMs >= 600 && (dx > 14 || dy > 14)) return true;
  return false;
}

/**
 * После pointerup даём браузеру завершить selection, затем проверяем.
 * @param {() => void} fn
 */
export function afterReaderSelectionSettled(fn) {
  if (typeof window === 'undefined') {
    fn();
    return;
  }
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      fn();
    });
  });
}
